import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { saveAs } from "file-saver";
import {
  Apis,
  getFourPLTableData,
  getListOfCustomers,
  prepareColumnChartData,
  prepareCustomerMLCD,
  prepareCustomerTableData,
  prepareModificationsMLCD,
  prepareModificationsTD,
  prepareMultiLineChartData,
  prepareNewCustomerTableData,
  prepareQuotaDetailsTableData,
  prepareScenarioTableData,
  prepareCustomersIncExcTableData,
  prepareScenarioOtherInfoTableData,
  prepareTableData,
  saveResponseAsJsonFile,
} from "./analyzeUtils";
import { json } from "react-router-dom";

const initialState = {
  isLoading: false,

  analysisTypes: [],
  selectedAnalysisType: "",
  selectedAnalysisTypeID: "",

  countries: [],
  selectedCountry: "",
  selectedCountryID: "",

  isActiveScenario: false,
  selectedDataPoints: [],

  scenarios: [],
  scenariosData: [],
  scenariosFullData: [],
  scenariosCust: [],
  scenariosMod: [],
  selectedScenarioName: "",
  selectedScenarioID: "",

  skuPgs: [],
  skuPgsData: [],
  skuPgsCust: [],
  skuPgsMod: [],
  selectedSkuPgName: "",
  selectedSkuPgID: "",

  customers: [],
  customersQD: [],
  customersData: [],
  customersCust: [],
  selectedCustCountry: "",
  selectedCustCountryID: null,
  selectedCustScenarioName: null,
  selectedCustScenarioID: null,
  selectedCustSkuPgName: "",
  selectedCustSkuPgID: null,
  selectedCustomerName: "",
  selectedCustomerID: "",
  custDuation: null,
  customerChecked: [],
  allCustomersSelected: false,

  duration: "",

  chartDataForData: null,
  multiLineChartData: null,
  multiLineChartDataPrepared: null,
  columnChartData: null,
  columnChartDataPrepared: null,
  tableData: null,
  tableDataPrepared: null,
  addedNewAnalyzeDataSource: null,

  apiResponse: null,

  newCustomerData: null,
  newCustomerDataPrepared: null,

  customerData: null,
  customerTD: null,
  customerTDPrepared: null, // TD -> Table Data
  customerMLCDPrepared: null, // MLCD -> Multi Line Chart Data

  scenarioChartData: null,
  scenarioChartDataPrepared: null,
  customersIncludedExcludedData:null,
  customersIncludedExcludedDataPrepared:null,
  scenarioOtherInfoData:null,
  scenarioOtherInfoDataPrepared:null,

  durations: [],

  quotaDetailsData: null,
  quotaDetailsDataPrepared: null,
  listQuotaDetails: [],
  redirectedQDLoading: false,
  selectedValueType: "",

  modificationsData: null,
  modificationsMLCD: null, // MLCD -> Multi Line Chart Data
  modificationsCustomers: [],
  modificationsSelCustomer: "",
  modificationsSelCustomerID: "",
  modificationsPeriods: [],
  modificationsSeries: [],
  modificationsTD: null, // TD -> Table Data
  modificationsTDRows: [],
  modificationsTDColumns: [],
  selectedDataPointsForModification: [],

  fourPLData: null,
  fourPLDataPrepared: null,
  selectedColumns: [],
  isDisPlayExport: true,

  //Trade Details
  tradeProducts: [],
  selectedTradeProduct: "",

  tradeForms: [],
  selectedTradeForms: [],
  selectedTradeForm: "",

  tradeStrength: [],
  selectedTradeStrengths: [],
  selectedTradeStrength: "",
  duration: null,
  productQuota: {},

  getAnalyzeCustomerNames: [],
  selectedCustomers: [],
  getIDChartData: [],

  selectedDataProductIds: [],
  selectedDataCustomerIds: [],
  customerList:[],
  customerIVDList:[],

  /*Generate Report */
  getFolderIdByName: "",
  getFolderContent: [],
  showOrHideExport: false,
  dataSource: [],
  dataSourceByCountry: [],
  getInDemandDataReport: [],
  selectedDataSource: "",
  selectedDataSourceID: "",
  selectedDurationID: "",
  selectedDurationName: "",

  clearDataValues: false,
  clearIVDValues: false,
  clearAnalyzeData: false,
  clearAnalyzeCustomer: false,
  clearAnalyzeNewCustomer: false,
  clearAnalyzeQuotaDetails: false,
  clearAnalyzeTradeDetails: false,
  clearAnalyzeIVD: false,
  clearAnalyze3PL: false,
  clearAnalyzeModifications: false,
  selectedDataskuIds: [],
  showChart: true,

  currentPageFlag: false,
  message:"",
  severity:"",
  messageOpen:false,
  isScenarioProgressionDetailsGridVisible:false,
  showTableData:false,
  showCustomerIncludedExcluded:false,

  redirectedFromDashboard: false,
  selectedSKUDesFilter: [],
  selectedScnarioFilter:[],
  selectedCustomerFilter:[],
  selectedOprConsFilter:"",
  selectedConsValFilter:"",
  searchFilterText:"",

  redirectedFromDashboardScenarioConsumption: false,
};

export const getAnalysisType = createAsyncThunk(
  "analyze/getAnalysisType",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.analysisTypes;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getUserCountries = createAsyncThunk(
  "analyze/getUserCountries",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.userCountries + `userid=${data.userID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarios = createAsyncThunk(
  "analyze/getScenarios",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, activeScenario, analyisID } = obj;
    const url =
      Apis.scenariosForCountry +
      `CountryId=${countryID}&IsActiveScenario=${activeScenario}&Analyzetype=${analyisID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenariosData = createAsyncThunk(
  "analyze/getScenariosData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, activeScenario, analyisID } = obj;
    const url =
      Apis.scenariosForCountry +
      `CountryId=${countryID}&IsActiveScenario=${activeScenario}&Analyzetype=${analyisID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenariosMod = createAsyncThunk(
  "analyze/getScenariosMod",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, activeScenario, analyisID } = obj;
    const url =
      Apis.scenariosForCountry +
      `CountryId=${countryID}&IsActiveScenario=${activeScenario}&Analyzetype=${analyisID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenariosForCustomer = createAsyncThunk(
  "analyze/getScenariosForCustomer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, activeScenario, analyisID } = obj;
    const url =
      Apis.scenariosForCountry +
      `CountryId=${countryID}&IsActiveScenario=${activeScenario}&Analyzetype=${analyisID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getSkuPg = createAsyncThunk(
  "analyze/getSkuPg",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.skuPGForScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getSkuPgData = createAsyncThunk(
  "analyze/getSkuPgData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.skuPGForScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getSkuPgMod = createAsyncThunk(
  "analyze/getSkuPgMod",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.skuPGForScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getSkuPgForCustomer = createAsyncThunk(
  "analyze/getSkuPgForCustomer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.skuPGForScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getChartDataForData = createAsyncThunk(
  "analyze/getChartDataForData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID, skuPgID, duration } = obj;
    const url = Apis.chartData;
    //+`ScenarioID=${scenarioID}&ProductId=${skuPgID}&Duration=${duration}`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const exportFile_Data = createAsyncThunk(
  "analyze/exportFile_Data",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      ProductName,
      ScenarioID,
      ScenarioName,
      chartImage,
      listAnalyseData,
      displayType,
    } = obj;
    const url = Apis.exportFile + `isPdf=${isPdf}&Type=Data&displayType=${displayType}`;
    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      ProductName,
      ScenarioID,
      ScenarioName,
      chartImage,
      listAnalyseData,
      displayType,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `AnalyzeData_${CountryName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const ExportFileForQuotaDetails = createAsyncThunk(
  "analyze/exportFileForQuotaDetails",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryName,
      Period,
      listAnalyseData,
    } = obj;
    const url = Apis.exportFileForQuotaDetails + `isPdf=${isPdf}`;
    const postBody = {
      AnalyzeTitle,
      CountryName,
      Period,
      listAnalyseData,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `AnalyzeQuotaDetails_${CountryName} ${Period}.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);


export const getNewCustomerData = createAsyncThunk(
  "analyze/getNewCustomerData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, duration } = obj;
    const url =
      Apis.newCustomerData + `CountryID=${countryID}&Duration=${duration}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const exportFile_NewCustomer = createAsyncThunk(
  "analyze/exportFile_NewCustomer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      listAnalyseData,
    } = obj;
    const url = Apis.exportFile + `isPdf=${isPdf}&Type=NewCustomer`;
    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      listAnalyseData,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `AnalyzeNewCustomer_${CountryName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCustomers = createAsyncThunk(
  "analyze/getCustomers",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.customersByScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCustomersData = createAsyncThunk(
  "analyze/getCustomersData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.customersByScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCustomersForCustomer = createAsyncThunk(
  "analyze/getCustomersForCustomer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID } = obj;
    const url = Apis.customersByScenario + `ScenarioID=${scenarioID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getChartDataForCustomer = createAsyncThunk(
  "analyze/getChartDataForCustomer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID, customerID, productID, duration } = obj;
    const url =
      Apis.customerChartData +
      `ScenarioID=${scenarioID}&CustomerID=${customerID}&ProductID=${productID}&Duration=${duration}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

//AddNewAnalyzeDataSource

export const AddNewAnalyzeDataSource = createAsyncThunk(
  "analyze/AddNewAnalyzeDataSource",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = Apis.addNewAnalyzeDataSource;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

///Analyze/SaveAnalyzeDataSource
export const SaveAnalyzeDataSource = createAsyncThunk(
  "analyze/SaveAnalyzeDataSource",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const url = Apis.saveAnalyzeDataSource;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const exportFile_Customer = createAsyncThunk(
  "analyze/exportFile_Customer",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      CustomerID,
      CustomerName,
      Duration,
      ProductName,
      ScenarioID,
      ScenarioName,
      listAnalyseData,
      chartImage,
    } = obj;
    const url = Apis.exportFile + `isPdf=${isPdf}&Type=Customer`;
    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      CustomerID,
      CustomerName,
      Duration,
      ProductName,
      ScenarioID,
      ScenarioName,
      listAnalyseData,
      chartImage,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `Analyze_${ScenarioName} - Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarioChartData = createAsyncThunk(
  "analyze/getScenarioChartData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioName, countryID } = obj;
    const url =
      Apis.scenarioChartData +
      `scenarioName=${scenarioName}&CountryId=${countryID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCustomersIncludedExcludedDetails = createAsyncThunk(
  "analyze/getCustomersIncludedExcludedDetails",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenario1, scenario2 } = obj;
    const url =
      Apis.getCustomersIncludedExcludedDetails +
      `Scenario1=${scenario1}&Scenario2=${scenario2}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      
      const jsonData = await response.json();
      //console.log("The api data in getCustomersIncludedExcludedDetails",jsonData);
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getScenarioOtherInfoData = createAsyncThunk(
  "analyze/getScenarioOtherInfoData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioName, countryID } = obj;
    const url =
      Apis.scenarioChartData +
      `scenarioName=${scenarioName}&CountryId=${countryID}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      //console.log("Scenario data in getScenarioOtherInfoData is ",jsonData);
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getCustomersByCountry = createAsyncThunk(
  "analyze/getCustomersByCountry",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, customerName } = obj;
    const url =
      Apis.customersByCountry +
      `CountryID=${countryID}&CustName=${customerName}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getDurations = createAsyncThunk(
  "analyze/getDurations",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.durations;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getQuotaDetailsData = createAsyncThunk(
  "analyze/getQuotaDetailsData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { countryID, duration, category } = obj;
    const url =
      Apis.quotaDetailsData +
      `CountryID=${countryID}&duration=${duration}&category=${category}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const exportFile_QuotaDetails = createAsyncThunk(
  "analyze/exportFile_QuotaDetails",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      CountryID,
      CountryName,
      CustomerIds,
      CustomerName,
      DurationForQuotaDetails,
      AnalyzeTitle,
      listAnalyseData,
    } = obj;
    const url = Apis.exportFileForQuotaDetails + `isPdf=${isPdf}`;
    const postBody = {
      CountryID,
      CountryName,
      CustomerIds,
      CustomerName,
      DurationForQuotaDetails,
      AnalyzeTitle,
      listAnalyseData,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `QuotaDetailsFor_${CountryName}_ForCustomer_${CustomerName}_For_${DurationForQuotaDetails}.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getModificationsData = createAsyncThunk(
  "analyze/getModificationsData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const { scenarioID, valueType, duration, packID } = obj;
    const url =
      Apis.modificationsData +
      `ScenarioId=${scenarioID}&Duration=${duration}&ValueType=${valueType}&PackGroupOrSKUID=${packID}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getPeriods = createAsyncThunk(
  "analyze/getPeriods",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.periods;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getFourPLData = createAsyncThunk(
  "analyze/getFourPLData",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { countryID, duration } = obj;
    const url =
      Apis.fourPLexport +
      `countryId=${countryID}&period=${duration}&userId=${userID}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      console.log("FourPL Data: ", jsonData);
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const Export4PLExportPartner = createAsyncThunk(
  "analyze/Export4PLExportPartner",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.export4PLExportPartner + "reportType=All";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const res = await response.blob();
      const extension = "xlsx";
      const fileName = `Analyze3PLExportPartner_${obj.countryName}_Last ${obj.period} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

//Trade Details
export const getAnalyzeTradeProducts = createAsyncThunk(
  "analyze/getAnalyzeTradeProducts",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { countryID } = obj;
    const url = Apis.getAnalyzeTradeProducts + `countryId=${countryID}`;
    //const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeTradeProducts?" +`countryId=${countryID}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getAnalyzeTradeForm = createAsyncThunk(
  "analyze/getAnalyzeTradeForm",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { countryID, productName } = obj;
    const url =
      Apis.getAnalyzeTradeForm +
      `CountryID=${countryID}` +
      `&ProductName=${productName}`;
    //const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeTradeForm?" + `CountryID=${countryID}` + `&ProductName=${productName}`
    //+`countryId=${countryID}&productName=${productName}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const getAnalyzeTradeStrength = createAsyncThunk(
  "analyze/getAnalyzeTradeStrength",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { countryID, productName, formsType } = obj;
    console.log(formsType);
    const url = Apis.getAnalyzeTradeStrength;
    //const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeTradeStrength"
    //+ `countryID=${countryID}` + `&productName=${productName}` + `&formsType=${formsType}`
    //+`countryId=${countryID}&productName=${productName}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

//http://172.19.79.4/amgen_sims_api/api/Analyze/GetProductQuota
export const getProductQuota = createAsyncThunk(
  "analyze/getProductQuota",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { countryID, productName, formsType } = obj;
    console.log(formsType);
    const url = Apis.getProductQuota;
    //+ `CountryID=${countryID}` + `&ProductName=${productName}`
    //const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetProductQuota"
    //+ `countryID=${countryID}` + `&productName=${productName}` + `&formsType=${formsType}`
    //+`countryId=${countryID}&productName=${productName}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const exportFile_TradeDetails = createAsyncThunk(
  "analyze/exportFile_TradeDetails",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      Type,
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      listAnalyseData,
    } = obj;
    const url = Apis.exportFile + `isPdf=${isPdf}&Type=${Type}`;
    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      Duration,
      listAnalyseData,
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `AnalyzeTradeDetails_${CountryName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

//Intended vs Delivered

// export const getAnalyzeTradeFormIvsD = createAsyncThunk(
// 	"analyze/getAnalyzeTradeFormIvsD",
// 	async (obj, thunkAPI) => {
// 		const data = JSON.parse(localStorage.getItem("data"));
// 		const token = data.token;
// 		const userID = data.userID;
// 		const { countryID, productName } = obj;
// 		//const url = Apis.getAnalyzeTradeForm + `CountryID=${countryID}` + `&ProductName=${productName}`
// 		const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeTradeForm?" + `CountryID=${countryID}` + `&ProductName=${productName}`
// 		//+`countryId=${countryID}&productName=${productName}`;

// 		try {
// 			const response = await fetch(url, {
// 				method: "GET",
// 				headers: {
// 					"Content-Type": "application/json",
// 					Authorization: `Bearer ${token}`,
// 					Accept: "application/json",
// 				},
// 			});
// 			const jsonData = await response.json();
// 			return jsonData;
// 		} catch (error) {
// 			console.error("Error: ", error);
// 		}
// 	}
// );

// export const getAnalyzeTradeStrengthIvsD = createAsyncThunk(
// 	"analyze/getAnalyzeTradeStrengthIvsD",
// 	async (obj, thunkAPI) => {
// 		const data = JSON.parse(localStorage.getItem("data"));
// 		const token = data.token;
// 		const userID = data.userID;
// 		const { countryID, productName, formsType } = obj;
// 		console.log(formsType)
// 		//const url = Apis.getAnalyzeTradeForm + `CountryID=${countryID}` + `&ProductName=${productName}`
// 		const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeTradeStrength"
// 		//+ `countryID=${countryID}` + `&productName=${productName}` + `&formsType=${formsType}`
// 		//+`countryId=${countryID}&productName=${productName}`;

// 		try {
// 			const response = await fetch(url, {
// 				method: "POST",
// 				headers: {
// 					"Content-Type": "application/json",
// 					Authorization: `Bearer ${token}`,
// 					Accept: "application/json",
// 				},
// 				body: JSON.stringify(obj)
// 			});
// 			const jsonData = await response.json();
// 			return jsonData;
// 		} catch (error) {
// 			console.error("Error: ", error);
// 		}
// 	}
// );

export const getAnalyzeCustomername = createAsyncThunk(
  "analyze/getAnalyzeCustomername",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const userID = data.userID;
    const { CountryID, ProductName, ScenarioId, Duration } = obj;
    const url =
      Apis.getAnalyzeCustomerName +
      //const url = "http://172.19.79.4/amgen_sims_api/api/Analyze/GetAnalyzeCustomername_Rv3?"
      `CountryID=${CountryID}` +
      `&ProductName=${ProductName}` +
      `&ScenarioId=${ScenarioId}` +
      `&Duration=${Duration}`;
    //+`countryId=${countryID}&productName=${productName}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const GetAnalyzeIntendDeliveredChart = createAsyncThunk(
  "analyze/GetAnalyzeIntendDeliveredChart",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    //const url = Apis.exportFile + `isPdf=${isPdf}&Type=${Type}`;
    const url = Apis.getAnalyzeIntendDeliveredChart;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const GetFolderIdByName = createAsyncThunk(
  "analyze/GetFolderIdByName",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = Apis.getFolderIdByName + "FolderName=" + obj.FolderName;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("analyze/GetFolderIdByName Error: ", error);
    }
  }
);

export const GetFolderContent = createAsyncThunk(
  "analyze/GetFolderContent",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = Apis.getFolderContent + "id=" + obj.id;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData.items;
    } catch (error) {
      console.error("analyze/GetFolderContent Error: ", error);
    }
  }
);

export const DownloadFile = createAsyncThunk(
  "analyze/DownloadFile",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = Apis.downloadFile + "fileId=" + obj.fileId;

    try {
      const response = await fetch(url, {
        method: obj.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const res = await response.blob();
      const fileName = obj.fileName;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("analyze/DownloadFile Error: ", error);
    }
  }
);

export const ExportInDemandReport = createAsyncThunk(
  "analyze/ExportInDemandReport",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const {
      isPdf,
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    } = obj;

    const url = Apis.exportInDemandReport + `isPdf=${isPdf}`;

    const postBody = {
      AnalyzeTitle,
      CountryID,
      CountryName,
      DataSourceID,
      DataSourceName,
      Duration,
      listAnalyseData,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(postBody),
      });
      const res = await response.blob();
      const extension = isPdf ? "pdf" : "xlsx";
      const fileName = `InDemandDataReport_${CountryName}_${DataSourceName} Last ${Duration} Months.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const ExportBackendReport = createAsyncThunk(
  "analyze/ExportBackendReport",
  async (obj, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = Apis.exportBackendReport;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(obj.query),
      });
      const res = await response.blob();
      const extension = "csv";
      const fileName = `${obj.tableName}_GeneratedReport.${extension}`;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const GetInDemandDataReport = createAsyncThunk(
  "analyze/GetInDemandDataReport",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url =
      Apis.getInDemandDataReport +
      "countryId=" +
      obj.countryId +
      "&dataSourceId=" +
      obj.dataSourceId +
      "&period=" +
      obj.period;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("analyze/GetInDemandDataReport Error: ", error);
    }
  }
);

export const GetDatasources = createAsyncThunk(
  "analyze/GetDatasources",
  async (obj) => {
    let reqOptions = {};
    reqOptions.method = obj.method;
    let url = Apis.getDatasources+"?countryId="+obj.countryId;
    return fetch(url, reqOptions).then((r) => {
      return r.json();
    });
  }
);

export const GetDatasourcesByCountry = createAsyncThunk(
  "analyze/GetDatasourcesByCountry",
  async (obj) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    const url = Apis.getDatasourcesByCountry + "countryId=" + obj.countryId;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("analyze/GetDatasourcesByCountry Error: ", error);
    }
  }
);

export const UpdateIsCustomerReviewed = createAsyncThunk(
  "analyze/UpdateIsCustomerReviewed",
  async (arr, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    //const url = Apis.exportFile + `isPdf=${isPdf}&Type=${Type}`;
    const url = Apis.updateIsCustomerReviewed;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(arr),
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const analyzeSlice = createSlice({
  name: "analyze",
  initialState,
  reducers: {
    setState: {
      prepare(stateName, stateValue) {
        return {
          payload: { stateName, stateValue },
        };
      },
      reducer(state, action) {
        const { stateName, stateValue } = action.payload;
        state[stateName] = stateValue;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAnalysisType.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAnalysisType.fulfilled, (state, action) => {
        state.analysisTypes = action.payload;
        state.isLoading = false;
      })
      .addCase(getAnalysisType.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getAnalysisType", action.error.message);
      })
      .addCase(getUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUserCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserCountries.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from GetUserCountries", action.error.message);
      })

      .addCase(getScenarios.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarios.fulfilled, (state, action) => {
        state.scenarios = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenarios.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenarios", action.error.message);
      })

      .addCase(getScenariosData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosData.fulfilled, (state, action) => {
        state.scenariosData = action.payload;
        state.scenariosFullData = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenariosData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenariosData", action.error.message);
      })

      .addCase(getScenariosMod.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosMod.fulfilled, (state, action) => {
        state.scenariosMod = action.payload;
        state.isLoading = false;
      })
      .addCase(getScenariosMod.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenariosMod", action.error.message);
      })

      .addCase(getSkuPg.pending, (state, action) => {
        //state.isLoading = true;
      })
      .addCase(getSkuPg.fulfilled, (state, action) => {
        state.skuPgs = action.payload;
        //state.isLoading = false;
      })
      .addCase(getSkuPg.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getSkuPg", action.error.message);
      })

      .addCase(getSkuPgData.pending, (state, action) => {
        //state.isLoading = true;
      })
      .addCase(getSkuPgData.fulfilled, (state, action) => {
        state.skuPgsData = action.payload;
        //state.isLoading = false;
      })
      .addCase(getSkuPgData.rejected, (state, action) => {
        //state.isLoading = false;
        console.error("Error from getSkuPgData", action.error.message);
      })

      .addCase(getSkuPgMod.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSkuPgMod.fulfilled, (state, action) => {
        state.skuPgsMod = action.payload;
        state.isLoading = false;
      })
      .addCase(getSkuPgMod.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getSkuPgMod", action.error.message);
      })

      .addCase(getChartDataForData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getChartDataForData.fulfilled, (state, action) => {
        state.chartDataForData = action.payload;
        state.multiLineChartData = action.payload.analyzeDataChartDataBOList;
        
        state.multiLineChartDataPrepared = prepareMultiLineChartData(
          action.payload.analyzeDataChartDataBOList
        );
        state.columnChartData = action.payload.analyzeDataBarChartBOList;
        state.columnChartDataPrepared = prepareColumnChartData(
          action.payload.analyzeDataBarChartBOList
        );
        state.tableData =
          action.payload.analyzeDataTableDataBOList[0].analyzeDataTableBO;
        state.tableDataPrepared = prepareTableData(
          action.payload.analyzeDataTableDataBOList[0].analyzeDataTableBO
        );
        state.isLoading = false;
      })
      .addCase(getChartDataForData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getChartDataForData", action.error.message);
      })

      .addCase(exportFile_Data.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(exportFile_Data.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(exportFile_Data.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from exportFile_Data", action.error.message);
      })

      .addCase(getNewCustomerData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getNewCustomerData.fulfilled, (state, action) => {
        state.newCustomerData = action.payload;
        state.newCustomerDataPrepared = prepareNewCustomerTableData(
          action.payload
        );
        state.isLoading = false;
      })
      .addCase(getNewCustomerData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getNewCustomerData", action.error.message);
      })

      .addCase(exportFile_NewCustomer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(exportFile_NewCustomer.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(exportFile_NewCustomer.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from exportFile_NewCustomer",
          action.error.message
        );
      })

      .addCase(getCustomers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCustomers.fulfilled, (state, action) => {
        state.customers = action.payload;
        state.isLoading = false;
      })
      .addCase(getCustomers.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getCustomers", action.error.message);
      })

      .addCase(getCustomersData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCustomersData.fulfilled, (state, action) => {
        state.customersData = action.payload;
        state.isLoading = false;
      })
      .addCase(getCustomersData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getCustomersData", action.error.message);
      })

      .addCase(getCustomersForCustomer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCustomersForCustomer.fulfilled, (state, action) => {
        state.customersCust = action.payload;
        state.isLoading = false;
      })
      .addCase(getCustomersForCustomer.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getCustomers", action.error.message);
      })

      .addCase(getChartDataForCustomer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getChartDataForCustomer.fulfilled, (state, action) => {
        state.customerData = action.payload;
        state.customerTD =
          action.payload.analyzeCustomerTableDataListBO[0].analyzeCustomerTableBO;
        state.customerTDPrepared = prepareCustomerTableData(
          action.payload.analyzeCustomerTableDataListBO[0]
            .analyzeCustomerTableBO
        );
        state.customerMLCDPrepared = prepareCustomerMLCD(
          action.payload.analyzeCustomerChartDataListBO
        );
        state.isLoading = false;
      })
      .addCase(getChartDataForCustomer.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from getChartDataForCustomer",
          action.error.message
        );
      })

      .addCase(exportFile_Customer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(exportFile_Customer.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(exportFile_Customer.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from exportFile_Customer", action.error.message);
      })

      .addCase(getScenarioChartData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioChartData.fulfilled, (state, action) => {
        state.scenarioChartData = action.payload;
        state.scenarioChartDataPrepared = prepareScenarioTableData(
          action.payload
        );
        state.isLoading = false;
      })
      .addCase(getScenarioChartData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenarioChartData", action.error.message);
      })
      .addCase(getCustomersIncludedExcludedDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCustomersIncludedExcludedDetails.fulfilled, (state, action) => {
        state.customersIncludedExcludedData = action.payload;
        state.customersIncludedExcludedDataPrepared = prepareCustomersIncExcTableData(
          action.payload
        );
        state.isLoading = false;
      })
      .addCase(getCustomersIncludedExcludedDetails.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getCustomersIncludedExcludedDetails", action.error.message);
      })
      .addCase(getScenarioOtherInfoData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenarioOtherInfoData.fulfilled, (state, action) => {
        state.scenarioOtherInfoData = action.payload;
        console.log("ACTION PAYLOAD",state.scenarioOtherInfoData);
        state.scenarioOtherInfoDataPrepared = prepareScenarioOtherInfoTableData(
          action.payload
        );
        state.isLoading = false;
      })
      .addCase(getScenarioOtherInfoData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getScenarioOtherInfoData", action.error.message);
      })

      .addCase(getCustomersByCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCustomersByCountry.fulfilled, (state, action) => {
        state.customersQD = action.payload;
        state.isLoading = false;
      })
      .addCase(getCustomersByCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getCustomersByCountry", action.error.message);
      })
      .addCase(getDurations.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDurations.fulfilled, (state, action) => {
        state.durations = action.payload;
        state.isLoading = false;
      })
      .addCase(getDurations.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getDurations", action.error.message);
      })

      .addCase(getQuotaDetailsData.pending, (state, action) => {
        state.isLoading = true;
        state.redirectedQDLoading = true;
        state.showOrHideExport = false;
      })
      .addCase(getQuotaDetailsData.fulfilled, (state, action) => {
        state.quotaDetailsData = action.payload;
        state.quotaDetailsDataPrepared = prepareQuotaDetailsTableData(
          action.payload
        );
        // console.log(action.payload);
        state.isLoading = false;
        state.redirectedQDLoading = false;
        state.showOrHideExport = true;
      })
      .addCase(getQuotaDetailsData.rejected, (state, action) => {
        state.isLoading = false;
        state.redirectedQDLoading = false;
        console.error("Error from getQuotaDetailsData", action.error.message);
        state.showOrHideExport = false;
      })

      .addCase(exportFile_QuotaDetails.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(exportFile_QuotaDetails.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(exportFile_QuotaDetails.rejected, (state, action) => {
        state.isLoading = false;
        console.error(
          "Error from exportFile_QuotaDetails",
          action.error.message
        );
      })

      .addCase(getModificationsData.pending, (state, action) => {
        state.isLoading = true;
        state.modificationsSeries = [];
      })
      .addCase(getModificationsData.fulfilled, (state, action) => {
        state.modificationsData = action.payload;
        state.modificationsCustomers = getListOfCustomers(
          action.payload.lstAnalyzeChartData
        );
        state.modificationsTD =
          action.payload.lstAnalyzeDataTable[0]?.analyzeModificationsDataTable;
        state.isLoading = false;
      })
      .addCase(getModificationsData.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from getModificationsData", action.error.message);
      })

      .addCase(getPeriods.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPeriods.fulfilled, (state, action) => {
        state.durations = action.payload;
        state.isLoading = false;
      })
      .addCase(getPeriods.rejected, (state, action) => {
        console.error("Error from getPeriods", action.error.message);
        state.isLoading = false;
      })

      .addCase(getFourPLData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getFourPLData.fulfilled, (state, action) => {
        state.fourPLData = action.payload;
        state.fourPLDataPrepared = getFourPLTableData(action.payload);
        state.isLoading = false;
      })
      .addCase(getFourPLData.rejected, (state, action) => {
        console.error("Error from getFourPLData", action.error.message);
        state.isLoading = false;
      })

      .addCase(getAnalyzeTradeProducts.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAnalyzeTradeProducts.fulfilled, (state, action) => {
        state.tradeProducts = action.payload;
        //state.tradeProducts = getAnalyzeTradeProducts(action.payload);
        state.isLoading = false;
      })
      .addCase(getAnalyzeTradeProducts.rejected, (state, action) => {
        console.error(
          "Error from getAnalyzeTradeProducts",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(getAnalyzeTradeForm.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAnalyzeTradeForm.fulfilled, (state, action) => {
        state.tradeForms = action.payload;
        state.isLoading = false;
      })
      .addCase(getAnalyzeTradeForm.rejected, (state, action) => {
        console.error("Error from getAnalyzeTradeForm", action.error.message);
        state.isLoading = false;
      })

      .addCase(getAnalyzeTradeStrength.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAnalyzeTradeStrength.fulfilled, (state, action) => {
        state.tradeStrength = action.payload;
        state.isLoading = false;
      })
      .addCase(getAnalyzeTradeStrength.rejected, (state, action) => {
        console.error(
          "Error from getAnalyzeTradeStrength",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(getProductQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProductQuota.fulfilled, (state, action) => {
        state.productQuota = action.payload;
        state.isLoading = false;
      })
      .addCase(getProductQuota.rejected, (state, action) => {
        console.error(
          "Error from getAnalyzeTradeStrength",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(getAnalyzeCustomername.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getAnalyzeCustomername.fulfilled, (state, action) => {
        state.getAnalyzeCustomerNames = action.payload;
        state.isLoading = false;
      })
      .addCase(getAnalyzeCustomername.rejected, (state, action) => {
        console.error(
          "Error from getAnalyzeCustomername",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(GetAnalyzeIntendDeliveredChart.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetAnalyzeIntendDeliveredChart.fulfilled, (state, action) => {
        state.getIDChartData = action.payload;
        state.isLoading = false;
      })
      .addCase(GetAnalyzeIntendDeliveredChart.rejected, (state, action) => {
        console.error(
          "Error from GetAnalyzeIntendDeliveredChart",
          action.error.message
        );
        state.isLoading = false;
      })

      .addCase(GetFolderIdByName.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderIdByName.fulfilled, (state, { payload }) => {
        state.getFolderIdByName = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderIdByName.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderIdByName", action.error.message);
      })

      .addCase(GetFolderContent.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetFolderContent.fulfilled, (state, { payload }) => {
        state.getFolderContent = payload;
        state.isLoading = false;
      })
      .addCase(GetFolderContent.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetFolderContent", action.error.message);
      })

      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from DownloadFile", action.error.message);
      })

      .addCase(ExportInDemandReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportInDemandReport.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportInDemandReport.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from ExportInDemandReport", action.error.message);
      })

      .addCase(ExportBackendReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ExportBackendReport.fulfilled, (state, action) => {
        state.apiResponse = action.payload;
        state.isLoading = false;
      })
      .addCase(ExportBackendReport.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Error from ExportBackendReport", action.error.message);
      })

      .addCase(GetDatasources.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetDatasources.fulfilled, (state, { payload }) => {
        // state.dataSource = payload;
        state.dataSourceByCountry = payload;
        state.isLoading = false;
      })
      .addCase(GetDatasources.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetDatasources", action.error.message);
      })

      .addCase(GetDatasourcesByCountry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetDatasourcesByCountry.fulfilled, (state, { payload }) => {
        state.dataSourceByCountry = payload;
        state.isLoading = false;
      })
      .addCase(GetDatasourcesByCountry.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetDatasourcesByCountry", action.error.message);
      })

      .addCase(GetInDemandDataReport.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(GetInDemandDataReport.fulfilled, (state, { payload }) => {
        state.getInDemandDataReport = payload;
        if (payload) {
          if (payload.length > 0) {
            state.showOrHideExport = true;
          } else state.showOrHideExport = false;
        } else state.showOrHideExport = false;
        state.isLoading = false;
      })
      .addCase(GetInDemandDataReport.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from GetInDemandDataReport", action.error.message);
      })

      .addCase(AddNewAnalyzeDataSource.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(AddNewAnalyzeDataSource.fulfilled, (state, { payload }) => {
        state.addedNewAnalyzeDataSource = payload;
        state.isLoading = false;
      })
      .addCase(AddNewAnalyzeDataSource.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from AddNewAnalyzeDataSource", action.error.message);
      })

      .addCase(getScenariosForCustomer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getScenariosForCustomer.fulfilled, (state, { payload }) => {
        state.scenariosCust = payload;
        state.isLoading = false;
      })
      .addCase(getScenariosForCustomer.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from AddNewAnalyzeDataSource", action.error.message);
      })

      .addCase(getSkuPgForCustomer.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSkuPgForCustomer.fulfilled, (state, { payload }) => {
        state.skuPgsCust = payload;
        state.isLoading = false;
      })
      .addCase(getSkuPgForCustomer.rejected, (state, action) => {
        state.isLoading = false;
        console.log("Error from AddNewAnalyzeDataSource", action.error.message);
      });

    //getSkuPgForCustomer
  },
});

export const { setState } = analyzeSlice.actions;
export default analyzeSlice.reducer;
